import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-last-production-orders-chart',
    templateUrl: './last-production-orders-chart.component.html',
    styleUrl: './last-production-orders-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LastProductionOrdersChartComponent {

}
